/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlProfileFieldResponseAny } from './ControlProfileFieldResponseAny';
import {
    ControlProfileFieldResponseAnyFromJSON,
    ControlProfileFieldResponseAnyFromJSONTyped,
    ControlProfileFieldResponseAnyToJSON,
} from './ControlProfileFieldResponseAny';

/**
 * 
 * @export
 * @interface ControlSaveProfileFieldsRequest
 */
export interface ControlSaveProfileFieldsRequest {
    /**
     * 
     * @type {Array<ControlProfileFieldResponseAny>}
     * @memberof ControlSaveProfileFieldsRequest
     */
    profile_fields: Array<ControlProfileFieldResponseAny>;
}

/**
 * Check if a given object implements the ControlSaveProfileFieldsRequest interface.
 */
export function instanceOfControlSaveProfileFieldsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "profile_fields" in value;

    return isInstance;
}

export function ControlSaveProfileFieldsRequestFromJSON(json: any): ControlSaveProfileFieldsRequest {
    return ControlSaveProfileFieldsRequestFromJSONTyped(json, false);
}

export function ControlSaveProfileFieldsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSaveProfileFieldsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile_fields': ((json['profile_fields'] as Array<any>).map(ControlProfileFieldResponseAnyFromJSON)),
    };
}

export function ControlSaveProfileFieldsRequestToJSON(value?: ControlSaveProfileFieldsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile_fields': ((value.profile_fields as Array<any>).map(ControlProfileFieldResponseAnyToJSON)),
    };
}

